import axiosInstance from "../../utils/config/config";

export const setAuthenticationState =
  (authenticated = false) =>
  async (dispatch) => {
    console.log("Dispatching authentication state:", authenticated);
    dispatch({
      type: "authenticationState",
      payload: authenticated,
    });
  };

export const getUserById = () => async (dispatch) => {
  try {
    dispatch({
      type: "userByIdRequest",
    });
    const { data } = await axiosInstance.get(`user/getUser`);
    dispatch({
      type: "userByIdSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "userByIdFailure",
      payload: true,
    });
  }
};

export const clearUserData = () => async (dispatch) => {
  try {
    dispatch({
      type: "clearUserData",
    });
  } catch (error) {}
};
